import React from "react";

const Footer = () => (
  <footer className="footer">
    <p>
      &copy; {new Date().getFullYear()} Maryville Massage Works. All rights
      reserved.
    </p>
    <span className="footer-signature">Saavik Erman, LMT</span>
  </footer>
);

export default Footer;
